import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PortMultieComponent, AgOverlayTemplate, AgEvent, AgAutoCompleteItem, MultiSelectItem, MultiSelectorComponent } from "../../components";
import { GridFareTransConfig } from "./fwdr-fare-management-grid-trans";
import { AgGridNg2 } from "ag-grid-angular";
import { GridApi, ColumnApi, CellValueChangedEvent } from "ag-grid";
import { Subscription } from "rxjs";
import { FareService, CallBack, FareTrans, Port, CrncyRateModel, Line, AirLine, PortService, OceanLineService, AirLineService, CurrencyService, AirPortService, AlertService, TransFareConditionModel, TransType, Country, UserService, FareCorp, CostItemService, CostItemModel, IncidFareConditionModel, FareIncid, ForwarderService, CorpIdNm, GridTransFareModel, GridIncidFareModel } from "../../services";
import { GridFareIncidConfig } from "./fwdr-fare-management-grid-incid";
import { SelectStyleDirective } from "app/directives";

@Component({
  selector: 'fwdr-fare-management',
  templateUrl: 'fwdr-fare-management.html'
})
export class FwdrFareManagement implements OnInit {
  
  private transTp: number;
  private crgoTp: number;
  
  private gridTransConfig = new GridFareTransConfig(this);
  private gridIncidConfig = new GridFareIncidConfig(this);

  private corpList: CorpIdNm[];
  private selectedCorpId: number;

  private get transType() {
    if (this.transTp == 0 && this.crgoTp == 0) return TransType.FCL;
    if (this.transTp == 0 && this.crgoTp == 1) return TransType.LCL;
    if (this.transTp == 1 && this.crgoTp == 1) return TransType.AIR;
    else return null;
  }

  private gridTransFareList: Array<GridTransFareModel> = [];
  private gridIncidFareList: Array<GridIncidFareModel> = [];
  
  @ViewChild('orgPortSelector') private orgPortSelector: PortMultieComponent;
  @ViewChild('desPortSelector') private desPortSelector: PortMultieComponent;
  @ViewChild('transCorpSel') private transCorpSel: ElementRef;

  @ViewChild('portSelector') private portSelector: PortMultieComponent;
  @ViewChild('incidCorpSel') private incidCorpSel: ElementRef;
  

  @ViewChild('gridTrans') gridTrans: AgGridNg2;
  gridTransApi: GridApi;
  gridTransColumnApi: ColumnApi;

  @ViewChild('gridIncid') gridIncid: AgGridNg2;
  gridIncidApi: GridApi;
  gridIncidColumnApi: ColumnApi;

  @ViewChild('gridIncidReq') gridIncidReq: AgGridNg2;
  gridIncidReqApi: GridApi;
  gridIncidReqColumnApi: ColumnApi;
  
  lines: Line[] = [];
  ports: Port[] = [];
  costItems: CostItemModel[] = [];
  portAutoCompleteItemList: AgAutoCompleteItem[] = [];
  currencyAutoCompleteItemList: AgAutoCompleteItem[] = [];
  lineAutoCompleteItemList: AgAutoCompleteItem[] = [];
  lineMultiSelectItems: MultiSelectItem[] = [];
  costItemAutoCompleteItemList: AgAutoCompleteItem[] = [];
  costItemMultieSelectItems: MultiSelectItem[] = [];
  
  getTransFareSubs: Subscription;
  getTransIncidSubs: Subscription;
  
  private get transColumnDefs() {
    if (this.transType == TransType.FCL) return this.gridTransConfig.colDefFclTrans;
    else if (this.transType == TransType.LCL) return this.gridTransConfig.colDefLclTrans;
    else if (this.transType == TransType.AIR) return this.gridTransConfig.colDefAirTrans;
    else return null;
  }

  private get frameworkCompsTrans() {
    if (this.transType == TransType.FCL) return this.gridTransConfig.frameworkCompsFclTrans;
    else if (this.transType == TransType.LCL) return this.gridTransConfig.frameworkCompsLclTrans;
    else if (this.transType == TransType.AIR) return this.gridTransConfig.frameworkCompsAirTrans;
    else return null;    
  }
  
  
  private get incidColumnDefs() {
    if (this.transType == TransType.FCL) return this.gridIncidConfig.colDefFclIncid;
    else if (this.transType == TransType.LCL) return this.gridIncidConfig.colDefLclIncid;
    else if (this.transType == TransType.AIR) return this.gridIncidConfig.colDefAirIncid;
    else return null;
  }

  private get frameworkCompsIncid() {
    if (this.transType == TransType.FCL) return this.gridIncidConfig.frameworkCompsFclIncid;
    else if (this.transType == TransType.LCL) return this.gridIncidConfig.frameworkCompsLclIncid;
    else if (this.transType == TransType.AIR) return this.gridIncidConfig.frameworkCompsAirIncid;
    else return null;
  }
  
  
  rowClassRules = {"deleted-row": (params) => params.data.isDel};
  overlayLoadingTemplate = AgOverlayTemplate.overlayProcessingTemplate;
  onGridKeyDown = AgEvent.onDelKeyDown;
  


  getPortItemListByCntry(cntry: Country): AgAutoCompleteItem[] {
    if (!cntry) return this.portAutoCompleteItemList;

    let cntryPortItemList = this.portAutoCompleteItemList.filter(
      item => {
        if (!item.data || !item.data.cntryCd ) return false;
        return item.data.cntryCd == cntry.cntryCd;
      }
    );

    return cntryPortItemList;
  }
  
  constructor(
    private route: ActivatedRoute,
    private fareService: FareService,
    private portService: PortService,
    private airportService: AirPortService,
    private oceanLineService: OceanLineService,
    private airLineService: AirLineService,
    private crncyService: CurrencyService,
    private alertService: AlertService,
    private costItemService: CostItemService,
    private fwdrMngService: ForwarderService
    ) {

    this.transTp = this.route.snapshot.data['transTp'];
    this.crgoTp = this.route.snapshot.data['crgoTp'];
    
    let ports = null;
    if (this.transTp == 0) ports = this.portService.ports;
    else ports = this.airportService.airports;
    if (!ports || ports.length <= 0) {
      if (this.transTp == 0) {
        this.portService.portListEe.subscribe(ports => this.initPortAutoCompleteItemList(ports));
      } else {
        this.airportService.airPortListEe.subscribe(airports => this.initPortAutoCompleteItemList(airports));
      }

    } else this.initPortAutoCompleteItemList(ports);
    
    let crncyList = this.crncyService.currencyList;
    if (!crncyList || crncyList.length <= 0) {
      this.crncyService.currencyListEe.subscribe(crncyList => this.initCurrencyAutoCompleteItemList(crncyList));
    } else this.initCurrencyAutoCompleteItemList(crncyList);
    

    let lines = null;
    if (this.transTp == 0) lines = this.oceanLineService.lineList;
    else lines = this.airLineService.lineList;
    if (!lines || lines.length <= 0) {
      if (this.transTp == 0) {
        this.oceanLineService.lineListEe.subscribe(lines => this.initOceanLineAutoCompleteItemList(lines));
      } else {
        this.airLineService.lineListEe.subscribe(lines => this.initAirLineAutoCompleteItemList(lines));
      }
    } else {
      if (this.transTp == 0) this.initOceanLineAutoCompleteItemList(lines);
      else this.initAirLineAutoCompleteItemList(lines);
    }

    let costItems = this.costItemService.costItemList;
    if (!costItems || costItems.length <= 0) {
      this.costItemService.costItemEe.subscribe(ci => this.initCostItemAutoCompleteItemList(ci));
    } else this.initCostItemAutoCompleteItemList(costItems);

  }
  
  ngOnInit() {
    this.fwdrMngService.getFareAuthCorpList().subscribe(resp => this.corpList = resp.data);
    
  }


  initPortAutoCompleteItemList (portList: Port[]) {
    this.ports = portList;
    this.portAutoCompleteItemList = portList.map((value:Port) => {
      let item = new AgAutoCompleteItem();
      item.value = '[' + value.portCd + '] ' + value.name;
      item.label = value.label;
      item.hiddenLabel = value.label + ' ' + value.labelKr;
      item.code = value.portCd;
      item.data = value;
      return item;
    })
  }

  initCurrencyAutoCompleteItemList(crncyList : CrncyRateModel[]) {
    this.currencyAutoCompleteItemList = crncyList.map<AgAutoCompleteItem>((value:CrncyRateModel) => {
      let item = new AgAutoCompleteItem();
      item.value = value.crncyCd;
      item.label = value.crncyCd;
      item.hiddenLabel = value.crncyCd;
      item.data = value;
      item.code = value.crncyCd;
      return item;
    });
  }

  initOceanLineAutoCompleteItemList(lines: Line[]) {
    this.lineAutoCompleteItemList = [];
    this.lines = lines;
    lines.forEach(line => {
      if (line.lineCd == 'ZZZ') return;
      
      let item: MultiSelectItem = new MultiSelectItem();
      item.value = line;
      item.label = line.lineCd;
      item.name = line.lineNm;
      item.isSelected = false;
      this.lineMultiSelectItems.push(item);

      let acItem: AgAutoCompleteItem = new AgAutoCompleteItem();
      acItem.value = '[' + line.lineCd + '] ' + line.lineNm;
      acItem.label = line.lineNm;
      acItem.hiddenLabel = line.lineCd;
      acItem.data = line;
      acItem.code = line.lineCd;
      this.lineAutoCompleteItemList.push(acItem);
    });
  }


  initAirLineAutoCompleteItemList(lines: AirLine[]) {
    this.lineAutoCompleteItemList = [];
    this.lines = [];
    lines.forEach(airport => {
      if (airport.lineCd == 'ZZZ') return;
      
      let line: Line = new Line();
      line.lineCd = airport.iataCd;
      line.lineNm = airport.name;
      this.lines.push(line);

      let item: MultiSelectItem = new MultiSelectItem();
      item.value = line;
      item.label = line.lineCd;
      item.name = line.lineNm;
      item.isSelected = false;
      this.lineMultiSelectItems.push(item);

      let acItem: AgAutoCompleteItem = new AgAutoCompleteItem();
      acItem.value = '[' + line.lineCd + '] ' + line.lineNm;
      acItem.label = line.lineNm;
      acItem.hiddenLabel = line.lineCd;
      acItem.data = line;
      acItem.code = line.lineCd;
      this.lineAutoCompleteItemList.push(acItem);
    });
  }

  initCostItemAutoCompleteItemList (costItems: CostItemModel[]) {
    let costItemMultieSelectItems: MultiSelectItem[] = [];
    let costItemAutoCompleteItemList: AgAutoCompleteItem[] = [];
    this.costItems = costItems;
    for (let costItem of costItems) {
      let item: MultiSelectItem = new MultiSelectItem();
      item.value = costItem;
      item.label = costItem.itemCd;
      item.name = costItem.itemNm;
      item.isSelected = false;
      costItemMultieSelectItems.push(item);
      
      let acItem: AgAutoCompleteItem = new AgAutoCompleteItem();
      acItem.value = '[' + costItem.itemCd + '] ' + costItem.itemNm;
      acItem.label = costItem.itemNm;
      acItem.hiddenLabel = costItem.itemCd;
      acItem.data = costItem;
      costItemAutoCompleteItemList.push(acItem);
    }
    this.costItemMultieSelectItems = costItemMultieSelectItems;
    this.costItemAutoCompleteItemList = costItemAutoCompleteItemList;
  }

  onGridTransReady(params) {
    this.gridTransApi = params.api;
    this.gridTransColumnApi = params.columnApi;
  }

  onGridIncidReady(params) {
    this.gridIncidApi = params.api;
    this.gridIncidColumnApi = params.columnApi;
  }

  onGridIncidReqReady(params) {
    this.gridIncidReqApi = params.api;
    this.gridIncidReqColumnApi = params.columnApi;
  }

  
  switchLocation() {
    this.orgPortSelector.switchValue(this.desPortSelector);
  }

  

  getTransFareList() {
    if (isNaN(this.transCorpSel.nativeElement.value)) {
      this.alertService.error('포워더를 선택하세요');
      return;
    }
    let corpId: number = this.transCorpSel.nativeElement.value;
    this.gridTransApi.showLoadingOverlay();

    let reqBody: TransFareConditionModel = new TransFareConditionModel();
    if (this.orgPortSelector.selectedPortList) reqBody.orgLocationList = this.orgPortSelector.selectedPortList.map<number>(port => port.locationId);
    if (this.desPortSelector.selectedPortList) reqBody.desLocationList = this.desPortSelector.selectedPortList.map<number>(port => port.locationId);
    
    if (this.getTransFareSubs) this.getTransFareSubs.unsubscribe();
    this.gridTransFareList = [];
    this.getTransFareSubs = this.fareService.getFwdrTransFare(this.transType, corpId, reqBody).subscribe(
      resp =>{
        this.gridTransApi.hideOverlay();
        if (resp.result) {
          let transFares: FareTrans[] = resp.data;
          let gridFareList: GridTransFareModel[] = [];
          if (!transFares || transFares.length <= 0) return;
          for (let fare of transFares) {
            let gridFare: GridTransFareModel = new GridTransFareModel(fare);
            let line: Line = this.lines.find(l => l.lineCd == gridFare.lineCd);
            gridFare.line = line;
            gridFareList.push(gridFare);
          }
          this.gridTransFareList = gridFareList;
        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );

  }

  


  getIncidFareList() {
    if (isNaN(this.incidCorpSel.nativeElement.value)) {
      this.alertService.error('포워더를 선택하세요');
      return;
    }
    let corpId: number = this.incidCorpSel.nativeElement.value;
    this.gridIncidApi.showLoadingOverlay();

    let reqBody: IncidFareConditionModel = new IncidFareConditionModel();
    if (this.portSelector.selectedPortList) reqBody.locationList = this.portSelector.selectedPortList.map<number>(port => port.locationId);
    
    if (this.getTransIncidSubs) this.getTransIncidSubs.unsubscribe();
    
    this.gridIncidFareList = [];
    
    this.getTransIncidSubs = this.fareService.getFwdrIncidFare(this.transType, corpId, reqBody).subscribe(
      resp =>{
        this.gridIncidApi.hideOverlay();
        if (resp.result) {
          let incidFares: FareIncid[] = resp.data;
          let gridFareList: GridIncidFareModel[] = [];
          for (let fare of incidFares) {
            let gridFare: GridIncidFareModel = new GridIncidFareModel(fare);
            gridFareList.push(gridFare);
          }
          this.gridIncidFareList = gridFareList;
        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );

  }


}





// WEBPACK FOOTER //
// ./src/app/containers/fwdr-fare/fwdr-fare-management.ts